export default {
    created: function () {
    },
    methods: {
    }
};